<template>
  <div class="proV2">
    
    <!-- {{minisite_data}} -->
    <!-- hero -->
    <!-- minisite_data={{minisite_data}} -->

    <div class="proHero">
        <prohero>
            <div class="heroContent">
                <img :src="getHeroLogoUrl" class="psLogo"/>
                <div class="psTitle fnH1">{{getHeroMainTitle}}</div>  
            </div>
            <div class="heroLinkBoxContainer">
              <prolinksbox 
                :catalogLinkData = "getCatalogLink()"
                :linksData = "getMediaLinks()">
              </prolinksbox>
            </div>
        </prohero>
    </div>

    <!-- why -->
    <!-- {{getWhySectionData()}} -->
    <div style="padding:3vw 5vw 1vw 5vw">
      <prowhy :sectionData="getWhySectionData()"></prowhy>
    </div>

    <!-- features -->
    <!-- {{getFeaturesSectionData()}} -->
    <div>
      <prohl :sectionData="getFeaturesSectionData()" @onShowPopupRequest="onShowPopupRequest"></prohl>
    </div>

    <!-- //////////// TECHNICAL INFORMATION ////////////  --> 
    <div class="proSection Technical" v-if="pageLayoutData">
        <div class="content">
            <div class="fnH1">Technical Information</div>    
            <div class="techCont">
              <div class="techTabsArea">
                <div class="techTabs3">
                  <ul>
                    <li @click="featureIndex=index" v-for="(item,index) in techMenu" 
                        :key="'feature_'+index" :class="[index == featureIndex ? 'selected':'']">
                      <span>{{item.title}}</span>
                    </li>
                  </ul>
                </div>
              </div>

<!--          <producttechvideo :componentData = "getTechnicalTabData('product-tech-video',0)"></producttechvideo>
              <producttechdimensions :componentData = "getTechnicalTabData('product-tech-dimensions',1)"></producttechdimensions>
              <producttechfeatures :componentData = "getTechnicalTabData('product-tech-features',2)"></producttechfeatures>
              <producttechpackaging :componentData = "getTechnicalTabData('product-tech-packaging',3)"></producttechpackaging>
 -->              

<!--     <producttechimplantrange
      :sectionType = "'product-tech-implant-range'"
      :sectionIndex = "4"
    ></producttechimplantrange> 
 -->
              <!-- :componentData = "getTechnicalTabData('product-tech-implant-range',4)" -->
              <div class="tabsContentArea">
                  <!-- todo: filter the techMenu array (in a computed method) to check which tab is making problem -->
                  <div  :class="['tabPanel',featureIndex==index ? 'visible':'']" 
                        v-for="(item,index) in techMenu" 
                        :key="'techcon_'+index">
                      
                       <!-- item.template={{item.template}} <br/>{{getComponentType(item.template)}} -->

                        <component 
                        :is="getComponentType(item.template)"
                        :sectionType = "getComponentType(item.template)"
                        :sectionIndex = "index">                          
                      </component> 

                      <!-- 
                        <component 
                        :is="getComponentType(item.template)"
                        :componentData = "getTechnicalTabData(item.template,index)">                          
                      </component> 
                      -->
     
                  </div>
              </div>
          </div>
      </div>
      <!-- //////////// TECHNICAL INFORMATION ////////////  --> 
    </div>


    <!--
        producttechvideo - ok
        producttechdimensions 
        producttechfeatures
        producttechpackaging
        producttechimplantrange
        producttechkit
        producttechdrilling
      -->
     

    <!-- getTechnicalTabData={{getTechnicalTabData(item.template)}} -->

                    <!-- tabs contents 
                      product-tech-video => producttechvideo
                      product-tech-dimensions
                      product-tech-features
                      product-tech-packaging
                      product-tech-implant-range
                      product-tech-kit
                      product-tech-drilling
                    -->

    <!-- //////////// TECHNICAL INFORMATION ////////////--> 

    <!-- {{getTechTabs()}} -->

    <!-- {{getPageSections}} -->    
    <!-- {{getTechSectionData}} -->
    <!--
      <b>getMediaLinks</b>
      {{getMediaLinks()}}
      <b>getCatalogLink</b><br/>
      {{getCatalogLink()}}
    -->
  </div>
</template>

<style>
  /* <!-- typography --> */
    :root
    {
        --fsH1: 32px;
        --lhH1: 33px;
    }
    @media (max-width: 850px) 
    { 
        :root{
          --fsH1: 26px;
          --lhH1: 28px;
        }
    }
    .fnH1
    {
      font-weight: 300 !important;
      font-size: var(--fsH1);
      line-height: var(--lhH1);
    }





</style>


<style scoped>
    .proV2
  {
      width: 100%;
      min-height: 50vh;
      position: relative;
      padding-bottom: 10vw;
    }    
    .techTabs3
    {
      padding: 16px 0px;      
      /* border-radius: 16px; */
      width: auto;
      display: inline-block;
      /* background: #f2f2f2; */
      width: auto;
      border-bottom: solid 1px #c7c7c7;
    }
    .techTabs3 ul
    {
      list-style: none;
      display: flex;
      flex-direction: row;
      column-gap: 24px;
      flex-shrink: 0;
      margin: auto;
      width: 100%;
    }
    .techTabs3 li
    {
      opacity: 0.4;
      cursor: pointer;
    }
    .techTabs3 li.selected
    {
      opacity: 1;
    }    
    .techTabs3 li span
    {
      color: #202020;
      font-weight: 400 !important;
      font-size: 13px;
    }    

    @media screen and (max-width: 815px)
    {
        .techCont{
          height: auto;
        }
        .techTabs3{
            padding: 10px 14px;
            width: 100%;
            overflow: hidden;           
        }
        .tabsContentArea
        {
          height: auto;
          padding-top: 30px;
        }
        .techTabs3 ul
        {
          -ms-overflow-style: none;  /* Internet Explorer and Edge */
          scrollbar-width: none;     /* Firefox */
          overflow: auto;            /* Fallback for other browsers */
          overflow-x: scroll;
          width: 100%;
        }
        .techTabs3 li
        {
            display: flex;
            align-items: center;
        }
        .tabPanel{
          height: auto;
          min-height: 110vw;
        }
        .heroContent
        {
          position: relative;
          left: 10vw;
          top: -30vw;          
        }
        .heroLinkBoxContainer
        {
            position: relative;
            top: 30vw;
            right: 6vw;          
        }
        
    }
</style>

<script>
import { subdomain } from "@/utils";
import { mapState, mapActions } from "vuex";
import prohero                    from "@/views/products/com/ProHero.vue";
import prolinksbox                from "@/views/products/com/ProLinksBox.vue";
import prowhy                     from "@/views/products/com/ProWhy4.vue";
import prohl                      from "@/views/products/com/ProHighlights2.vue";

import producttechvideo           from "@/views/products/com/TechVideo.vue";
import producttechimplantrange    from "@/views/products/com/TechRange.vue";
import producttechfeatures        from "@/views/products/com/TechFeatures.vue";
import producttechdrilling        from "@/views/products/com/TechDrilling.vue";
import producttechdimensions      from "@/views/products/com/TechDimensions.vue";

//import producttechpackaging  from "@/views/products/com/TechPackage.vue";
import producttechpackaging       from "@/views/products/com/TechKit.vue";
import producttechkit             from "@/views/products/com/TechKit.vue";
import techinfo                   from "@/views/products/com/TechInfo.vue";
import hpCases                    from '@/views/home/hpCases.vue';
import TempProductPage from '../views/temp/TempProductPage.vue';

//import LayoutGroup from "@/layout/LayoutGroup.vue";
export default {
  props: {
    css: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      // pageReady: false,
      featureIndex:0,
      ro: null,
      elementSizes: [],
      minisite_data:null,
      minisite_dictionary:null,
      minisite_ready:false,
      resizeTrig: -1    
    };
  },
  components: {
    prohero,
    prolinksbox,
    prowhy,
    prohl,
    hpCases,
    producttechvideo,
    producttechdimensions,
    producttechimplantrange,
    techinfo,
    producttechfeatures,
    producttechpackaging,
    producttechdrilling,
    producttechkit
  },
  watch: {
  },
  mounted()
  {
      var vm=this;
      //vm.seIimplantsRange();
      vm.initScrollListener();
      setTimeout(() => {
        vm.loadData();  
      }, 1000);

  },
  created()  
  {            
      var vm = this;
      setTimeout(() => {
        //vm.loadData();  
      }, 1000);
  },  
  computed: {
    ...mapState(["pageLayoutData", "rawitems", "pageReady"]),
    getHeroLogoUrl()
    {
      var logoName = this.pageLayoutData.title_logo.replace("@","");
      return "https://www.mis-implants.com/img/product-logos/"+logoName+".svg";      
    },
    getHeroMainTitle()
    {
      return this.pageLayoutData.sub_title; 
    },
    getPageSections()
    {
      return this.pageLayoutData.children[0].children; 
    },
    getTopLinks()
    {
      return this.pageLayoutData.children[0]; 
    },
    techMenu()
    {
      return this.getTechTabs();//<<<<filter to test which component is causing resize issues 
      //test filter
      //use only one item from the array 
      //return this.getTechTabs().filter((element, index) => {
        //return index === 0 ;
      //});
    }
  },
  methods: {
    ...mapActions([
      "setMinisiteData",
      "setMinisiteDic",
      "setPageReady",
      "initRouteByCid",
      "initRouteByPath",
      "initRawItems",
      "toggleOverlay",
      "setCountries"
    ]),
    getTechnicalTabData(sectionType,index)
    {
        //get the data from minisite_data by filtering by sectionType
        var tempData = {};
        var dataSectionName = "";
        if(sectionType=="product-tech-implant-range"){
            dataSectionName = "implant_range";
        }
        if(dataSectionName.length>0)
        {
          //fetch the data from the static JSON file
          //return this.minisite_data.SECTIONS[this.sectionDataIndex].platforms[this.plaformIndex].items;//.platforms[this.plaformIndex].items;
          tempData = this.minisite_data.SECTIONS.filter(x=> x.section == dataSectionName)[0];//"section":"implant_range",
        }
        else
        {
          //fetch the data from the real admin db (api)
          return this.getTechSectionData().children[0].children[index];//
        }
        return tempData;
    },
    onShowPopupRequest()
    {
      //dosomething
    },
    loadData() 
    {
      //let lc = this.getLangByRoute();                
      this.loadSiteData("site_data.json");
    },
    loadSiteData(fileName)
    {
      var vm = this;
      var APP_SITE_NAME = "";/////check according to the product name      
      if(this.pageLayoutData.title.toLowerCase().indexOf("lynx")>-1){
        APP_SITE_NAME="lynx";////<<<<<check why not lynx 
      }

      //var apiURL = "https://mis-implants.com/"+"content/"+APP_SITE_NAME+"/data/"+fileName;
      var apiURL = "/content/"+APP_SITE_NAME+"/data/"+fileName;
      ////alert("apiURL="+apiURL);

      fetch(apiURL, 
      {
          method: "GET",cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          headers: {"Content-Type": "application/json;charset=UTF-8",'Access-Control-Allow-Origin': '*'},
      })
      .then(function(response){ return response.json();})
      .then(function(response){

          if(fileName=="site_data.json"){
            vm.minisite_data = response;
            vm.setMinisiteData(response);
            vm.loadSiteData("site_dictionary.json");
          }
          if(fileName=="site_dictionary.json"){
            vm.minisite_dictionary = response;
            vm.setMinisiteDic(response);
            vm.minisite_ready = true;              
          }
        })
        .catch(err => {
          ///console.error("Fetch failed:", err);
          ////alert("Fetch failed, see console:"+err);
          //Fetch failed, see console:TypeError: Failed to fetch
        });
    },       
    seIimplantsRange()
    {
      var vm = this;        
      //vm.implantsRange = [{platform:''}]
      //todo: load the product json file for static info

    },
    getComponentType(compType)
    {
        let stringWithoutDashes = compType.replace(/-/g, "");
        return stringWithoutDashes;
    },
    getSectionByName(sectionType)
    {
        //getSectionByName("propage-media")
        //catalog-link"
        //propage-why
        //propage-features
        //propage-technical
        var sec = this.getPageSections;
        var section  = sec.filter(x => x.type == sectionType);
        return section[0];
    },
    getSectionMediaByType(sectionType,mediaType)
    {
        var sectionData = this.getSectionByName(sectionType);
        var media = sectionData.children;
        var mediaItems  = media.filter(x => x.media_type_id == mediaType);
        return mediaItems;
    },
    getMediaLinks()
    {
      //GET ALL MEDIA LINKS
      return this.getSectionMediaByType("propage-media",19);
    },
    getCatalogLink()
    {
      //GET CATALOG LINK
      return this.getSectionByName("catalog-link");
    },
    getWhySectionData()
    {
      //GET WHY SECTION
        return this.getSectionByName("propage-why");//prowhy
    },
    getFeaturesSectionData()
    {
        return this.getSectionByName("propage-features");//
    },
    getTechSectionData()
    {
      return this.getSectionByName("propage-technical");//
    },
    getTechTabs()
    {
        return this.getTechSectionData().children[0].children;//
    },
    initScrollListener() 
    {
      var vm=this;
      setTimeout(() => {    
        document.addEventListener("scroll", vm.scrollHandler, false);
      }, 1000);
    },    
    scrollHandler() 
    {      
      var vm=this;      
      vm.checkVideoSection("proHero1");
      vm.checkPageElements();
    },
    checkPageElements()
    {
        //query all elements with 'scroll-clip' class
        var pageElements = document.querySelectorAll(".scroll-clip");
        for (var i = 0; i < pageElements.length; i++){
            this.checkPageElement(pageElements[i]);
        }

        //check other fx element
        const thumbs = document.querySelectorAll('.scroll-thumb');
        thumbs.forEach(thumb => 
        {
            const rect = thumb.getBoundingClientRect();
            const img = thumb.querySelector('img');
            var windowHeight = window.innerHeight;
            windowHeight = windowHeight - 300;//remove footer height 
            const scrlProg = 1 - Math.max(0, Math.min(1, (rect.top + rect.height) / (windowHeight + rect.height)));
            //vm.debug1="scrlProg="+scrlProg;

            //spped of movement (30-60)
            //const offset = 0 - (scrlProg * 60);//direction up
            const offset = 0 - (scrlProg * 45);//direction up

            //const offset = -20 + (scrlProg * 50);//direction down
            //img.style.transform = `translateY(${offset}px)`;
            img.style.transform = "translateY("+offset+"%)";

            //const h5Element = thumb.querySelector('h5');
            //h5Element.innerText = "offset="+offset;
        });

    },
    getElementScrollPosition(el) {
      const rect = el.getBoundingClientRect();
      const viewHeight = window.innerHeight || document.documentElement.clientHeight;
      if (rect.bottom < 0) {
        // Element is completely above the viewport
        return 'above';
      } else if (rect.top > viewHeight) {
        // Element is completely below the viewport
        return 'below';
      } else {
        // Element is (at least partially) visible
        return 'visible';
      }
    },
    checkSectionsView()
    {
      var sectionElements = document.querySelectorAll(".proSection");
      var secondElement = sectionElements[1];
      var secondPos = this.getElementScrollPosition(secondElement);
      if(secondPos=='above'){
        this.showProSideMenu=false;
      }else{
        this.showProSideMenu=true;
      }
    },
    onSectionVisible(domSectionIndex)
    {        
        var vm=this;
    },    
    revealSectionChildrenElements(parentElement,domSectionIndex) 
    {
      var vm=this;
    },
    onRevealingSection(sectionID)
    {
        //add here specific site logic ...
    },       
    setActiveIndex(index)
    {
        this.activeIndex = index;
    },
    checkPageElement(element)
    {
      if(!element){
        return false;
      }
      var windowHeight = window.innerHeight;              
      var elementTop = element.getBoundingClientRect().top;
      var elementH = element.getBoundingClientRect().height;
      var topRef = elementTop/windowHeight;
      var transformRef = 0;    

      var minTop = 0.2;//0.3;
      var maxTop = -0.7;//-0.7;

      //clip-path shrink options:
      //var inRangeRef = Math.abs(topRef - minTop);//this will shrink back the clip-path when the element goes up
      var inRangeRef = topRef - minTop;//this will keep the clip-path full after the element went up
      
      transformRef = inRangeRef;//<<final value for transformation                   
      
      var clipPathRef = 20 * transformRef;//10
      var clipCornerRef = 30;// * transformRef;

      var progVal = 1-Math.abs(inRangeRef);
      element.setAttribute("data-prog", progVal);
      if(progVal>0.5){
        element.classList.add("scroll-visible")
      }

      //"opacity:"+progVal+";"+
      var clipStyle = "clip-path: inset("+clipPathRef+"% round "+clipCornerRef+"px);";
      element.style = clipStyle;

    },    
    checkVideoSection(heroElementID)
    {
      //check a video/promo section 
      //transform the clip-path according to it's scroll view
      let heroEl= document.getElementById(heroElementID);
      if(!heroEl){
        return false;
      }
      var windowHeight = window.innerHeight;              
      var videoElementTop = heroEl.getBoundingClientRect().top;
      var videoH = heroEl.getBoundingClientRect().height;
      var topRef = videoElementTop/windowHeight;
      var transformRef = 0;                
      var minTop = 0.2;//0.3;
      var maxTop = -0.7;//-0.7;
      var range = minTop - maxTop; // range is 1                
      var inRangeRef = Math.abs(topRef - minTop);
      if(inRangeRef>1){
        inRangeRef=1;//end of transformation// the video is minimized to it's minimum
      }
      if(inRangeRef<0.1)//if(inRangeRef<0.1)
      {
        inRangeRef=0;//start the transformtion a bit later while scrolling 
      }                    
      transformRef = inRangeRef;//<<final value for transformation              

      var clipPathRef = 11 * transformRef;//10
      var clipCornerRef = 40 * transformRef;
      var clipStyle = "clip-path: inset("+clipPathRef+"% round "+clipCornerRef+"px);";
      heroEl.style = clipStyle;
  }    
  }
};
</script>

